import LogoIcon from "assets/images/logo-dark.png";

const Logo = () => {
  return (
    <div className="">
      <a
        href="https://crm.id/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-link-primary"
      >
        <img width={99} src={LogoIcon} alt="Logo" />
      </a>
    </div>
  );
};

export default Logo;
